<app-loading *ngIf="loading"></app-loading>

<div class="container" *ngIf="!loading">
  <app-header></app-header>

  <div class="body">
    <app-title [enableBackButton]="true" [enableCloseButton]="false" (clickBack)="handleBack()" [title]="'Entrar ou cadastrar'"></app-title>
    
    <div class="login-container" *ngIf="step == 1">
      <div class="title">
        <h3>Entrar ou cadastrar</h3>
      </div>

      <div class="content">
        <p>Qual o seu celular</p>
        <app-flag-phone-input (dataEmitter)="handlePhoneData($event)"></app-flag-phone-input>
      </div>
    </div>
    <div class="register-container" *ngIf="step == 2">
      <div class="register-top">
        <div class="title">
          <h3>Cadastro</h3>
        </div>
        <p class="subtitle">Para usar, precisamos primeiro dos seus dados.</p>
      </div>

      <div class="content">
        <label for="">Nome<span>*</span></label>
        <input type="text" [(ngModel)]="name" (keyup)="handleName()" placeholder="Ex: João">
      </div>
    </div>
  </div>

  <div class="footer">
    <yoo-button
      primary
      large
      emphasis
      iconRight="arrow-right"
      [disabled]="!canAdvance"
      [block]="true"
      (click)="handleNextStep()"
    >
      <span *ngIf="step < 3">Próximo</span>
      <span *ngIf="step == 3">Confirmar</span>
    </yoo-button>
  </div>
</div>